export { default } from './Disclaimer';
export { default as adapter } from './adapter';
